webpackJsonp([279506944079389],{

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(24);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _car = __webpack_require__(136);
	
	var _car2 = _interopRequireDefault(_car);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorporateProgramEs = function CorporateProgramEs() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page corporate_program' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Nicaragua Programa Corporativo Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Preguntas frecuentes sobre el alquiler de autos.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './en/corporate_program'
	      }]
	    }),
	    _react2.default.createElement('div', { className: 'image' }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Programa Corporativo'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Tenemos el veh\xEDculo que se adapta a las necesidades de tu negocio.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Nuestro programa corporativo ofrece beneficios exclusivos para afiliados:'
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Tarifas especiales'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Cr\xE9dito corporativo'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Atenci\xF3n personalizada con un ejecutivo dedicado a su cuenta'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Atenci\xF3n personalizada'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Aprobaci\xF3n de cr\xE9dito inmediato'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'tarifas fijas durante todo el a\xF1o.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Servicio a domicilio sin costo adicional (aplican restricciones)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Conductor adicional sin costo.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Exoneraci\xF3n de cargo de Aeropuerto.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Programa de renta mensual (aplican restricciones)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Descuentos para sus colaboradores.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '\xA1La mejor opci\xF3n para tu empresa!',
	          _react2.default.createElement('br', null),
	          'Cont\xE1ctanos para obtener la mejor soluci\xF3n de transporte para tu empresa, con la calidad, el servicio y la confianza que solo Budget te puede ofrecer.'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:negocios@budget.com.ni', className: 'btn' },
	            'Cont\xE1ctenos'
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = CorporateProgramEs;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-corporate-program-es-js-2baede1508eccdc4a5b9.js